import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { AuthenticationService } from '../../services/authentication-services';
import { AlertService } from '../../services/alert.service';
import { environment } from '../../../environments/environment';

@Component({
    templateUrl: 'login.template.html',
    styleUrls: ['login.styles.scss']
})
export class LoginComponent implements OnInit {
    env: any = environment;
    model: any = {};
    loading = false;

    constructor(private router: Router, private authenticationService: AuthenticationService, private alert: AlertService) { }

    ngOnInit() {
        console.log(this.env);
        this.authenticationService.logout();
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(result => {
                if (result === true) {
                    this.alert.success('Аутентификация успеша');
                    this.router.navigate(['/device-list']);
                } else {
                  this.alert.error('Неверное имя пользователя или пароль');
                    this.loading = false;
                }
            }, error => {
              console.log(error);
              if(!error.status) this.alert.error('Системная ошибка при авторизации! Обратитесь к администрации ресурса');
              else if (error.status === 401) this.alert.error('Неверное имя пользователя или пароль');
              else this.alert.error('Системная ошибка при авторизации! Обратитесь к администрации ресурса');
              this.loading = false
            });
    }
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/login/login.component.ts